
import { isProfileLimitReached, isDuplicateProfileType, isDuplicateProfileName,isCustomProfileNameValid } from "./ValidationHelper";
import profileTypesData from "../Data/App_data/app_fixed_data.json";

/**
 * generateProfileOptions function is designed to format and return profile options, making it reusable across different components like popovers, dropdowns, or other UI elements. It takes an array of profiles and an optional flag to include the "Create Profile" option in the list.
 *
 * @param {Array} profiles - Array of profile objects from context.
 * @param {boolean} includeCreateOption - Whether to include the "Create Profile" option.
 * @returns {Array} - An array of formatted profile options.
 */
export const generateProfileOptions = (profiles = []) => {
  const profileCount = profiles.length;

  const options = [];

  // Add fixed options with conditionally disabled states
  options.push({
    value: "show",
    label: "Show Profile",
    isDisabled: profileCount <= 0,
  });

  options.push({
    value: "add",
    label: "Add Profile",
    isDisabled: profileCount > 5,
  });

  options.push({
    value: "delete",
    label: "Delete Profile",
    isDisabled: profileCount <= 0,
  });

  options.push({
    value: "archive",
    label: "Archive Profile",
    isDisabled: profileCount <= 0,
  });

  return options;
};

/**
 * Deletes a profile from the given list by value.
 * @param {Array} profiles - The array of profiles.
 * @param {string} profileValue - The value of the profile to delete.
 * @returns {Array} - The updated profiles array after deletion.
 */
export const deleteProfileByValue = (profiles, profileValue) => {
  if (!profileValue) {
    console.error("No profile value provided for deletion.");
    return profiles;
  }

  // Filter out the profile with the matching value
  return profiles.filter((profile) => profile.value !== profileValue);
};

/**
 * Generates profile options for deletion dropdown.
 * @param {Array} profiles - Array of profile objects.
 * @returns {Array} - Formatted options for dropdown.
 */
export const generateProfileOptionsForDelete = (profiles) => {
  return profiles.map((profile) => ({
    value: profile.value,
    label: profile.label,
  }));
};

//You can use getSelectedProfile in components to fetch the selected profile's details if needed.
export const getSelectedProfile = (profiles, selectedProfileValue) => {
  return profiles.find((profile) => profile.value === selectedProfileValue);
};

//If you want to filter out the selected profile from options dynamically, use a function like:
export const getProfileOptionsExcludingSelected = (profiles, selectedProfile) => {
  return profiles.filter((profile) => profile.value !== selectedProfile);
};


/** Encapsulate all validation logic for a Profilation Creation into a reusable function  */
export const validateProfile = (profiles, profileType, profileName, maxLimit,useCustomName, customProfileName) => {
  if (isProfileLimitReached(profiles, maxLimit)) {
    return "Cannot create more than 5 profiles.";
  }
  if (!profileTypesData.Profile_Types.includes(profileType)) {
    return "Invalid profile type. Please choose a valid profile type.";
  }
  if (isDuplicateProfileType(profiles, profileType)) {
    return "Profile type already exists.";
  }
  if (isDuplicateProfileName(profiles, profileName)) {
    return "Profile name already exists.";
  }
  if (isCustomProfileNameValid(useCustomName, customProfileName)) {
    return "Profile name already exists.";
  }
    
    
  return null;
};
